
import { ArrowRight, Clock } from "lucide-react";

const StickyCtaBar = () => {
  const handleJoinWaitlist = () => {
    const joinWaitlistSection = document.getElementById('join-waitlist');
    if (joinWaitlistSection) {
      joinWaitlistSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-gradient-to-r from-yellow-500 via-amber-500 to-orange-500 border-t border-yellow-400/30 shadow-2xl backdrop-blur-sm">
      <div className="max-w-7xl mx-auto px-3 sm:px-4 lg:px-8 py-2 sm:py-3">
        <div className="flex items-center justify-between gap-2 sm:gap-4">
          <div className="flex items-center gap-2 sm:gap-3 min-w-0 flex-1">
            <div className="w-2 h-2 bg-red-500 rounded-full animate-pulse flex-shrink-0" aria-hidden="true"></div>
            <div className="text-black min-w-0">
              <span className="font-bold text-xs sm:text-sm lg:text-base truncate block">Join the ZimKonnect Beta</span>
              <span className="hidden sm:inline text-xs lg:text-sm opacity-80">• Limited spots available</span>
            </div>
            <div className="hidden md:flex items-center gap-1 bg-black/10 px-2 py-1 rounded-full flex-shrink-0">
              <Clock className="w-3 h-3" aria-hidden="true" />
              <span className="text-xs font-medium">Early Access</span>
            </div>
          </div>
          
          <button
            onClick={handleJoinWaitlist}
            className="bg-black text-white px-3 sm:px-4 lg:px-6 py-2 sm:py-2.5 lg:py-3 rounded-full font-bold text-xs sm:text-sm lg:text-base hover:bg-gray-800 transition-all duration-300 transform hover:scale-105 shadow-lg flex items-center gap-1 sm:gap-2 min-h-[40px] sm:min-h-[44px] touch-manipulation flex-shrink-0"
            aria-label="Join ZimKonnect beta waitlist for early access to Zimbabwe project tracking"
          >
            <span>Join ZimKonnect Waitlist</span>
            <ArrowRight className="w-3 h-3 sm:w-4 sm:h-4" aria-hidden="true" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default StickyCtaBar;
